import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';

/**
 * Modal that displays an uploaded GCash payment proof image.
 * Extracted from OperatorToday to reduce component size.
 */
export default function PaymentProofDialog({ open, onOpenChange, playerName, proofUrl }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="payment-proof-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Payment Proof - {playerName}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          {proofUrl && (
            <img
              src={proofUrl}
              alt="Payment proof"
              className="w-full max-h-96 object-contain rounded-xl border border-gray-200"
            />
          )}
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="rounded-full"
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
